// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DownloadFiduciaryReportV2MutationVariables = Types.Exact<{
  householdID: Types.Scalars['ID']['input'];
}>;


export type DownloadFiduciaryReportV2Mutation = { __typename?: 'Mutation', exportFiduciaryReportV2: { __typename?: 'FileDownloadToken', token: string, expiresInSeconds: number } };

export const Operations = {
  Mutation: {
    DownloadFiduciaryReportV2: 'DownloadFiduciaryReportV2' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const DownloadFiduciaryReportV2Document = gql`
    mutation DownloadFiduciaryReportV2($householdID: ID!) {
  exportFiduciaryReportV2(householdID: $householdID) {
    token
    expiresInSeconds
  }
}
    `;
export type DownloadFiduciaryReportV2MutationFn = Apollo.MutationFunction<DownloadFiduciaryReportV2Mutation, DownloadFiduciaryReportV2MutationVariables>;

/**
 * __useDownloadFiduciaryReportV2Mutation__
 *
 * To run a mutation, you first call `useDownloadFiduciaryReportV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadFiduciaryReportV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadFiduciaryReportV2Mutation, { data, loading, error }] = useDownloadFiduciaryReportV2Mutation({
 *   variables: {
 *      householdID: // value for 'householdID'
 *   },
 * });
 */
export function useDownloadFiduciaryReportV2Mutation(baseOptions?: Apollo.MutationHookOptions<DownloadFiduciaryReportV2Mutation, DownloadFiduciaryReportV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadFiduciaryReportV2Mutation, DownloadFiduciaryReportV2MutationVariables>(DownloadFiduciaryReportV2Document, options);
      }
export type DownloadFiduciaryReportV2MutationHookResult = ReturnType<typeof useDownloadFiduciaryReportV2Mutation>;
export type DownloadFiduciaryReportV2MutationResult = Apollo.MutationResult<DownloadFiduciaryReportV2Mutation>;
export type DownloadFiduciaryReportV2MutationOptions = Apollo.BaseMutationOptions<DownloadFiduciaryReportV2Mutation, DownloadFiduciaryReportV2MutationVariables>;